declare namespace $ {

	type $shm_hitalama_text_embed__uri_shm_hitalama_text_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['link_uri'] >
		,
		ReturnType< $shm_hitalama_text_embed['uri'] >
	>
	type $shm_hitalama_text_embed__title_shm_hitalama_text_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['line_text'] >
		,
		ReturnType< $shm_hitalama_text_embed['title'] >
	>
	type $shm_hitalama_text__uri_resolve_shm_hitalama_text_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['uri_resolve'] >
		,
		ReturnType< $shm_hitalama_text['uri_resolve'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_text_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['quote_text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $shm_hitalama_text__highlight_shm_hitalama_text_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['highlight'] >
		,
		ReturnType< $shm_hitalama_text['highlight'] >
	>
	type $shm_hitalama_text__favicon_shm_hitalama_text_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['favicon'] >
		,
		ReturnType< $shm_hitalama_text['favicon'] >
	>
	type $shm_hitalama_text__auto_scroll_shm_hitalama_text_7 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_hitalama_text['auto_scroll'] >
	>
	type $shm_hitalama_text_code__text_shm_hitalama_text_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['pre_text'] >
		,
		ReturnType< $shm_hitalama_text_code['text'] >
	>
	type $shm_hitalama_text_code__row_themes_shm_hitalama_text_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['pre_themes'] >
		,
		ReturnType< $shm_hitalama_text_code['row_themes'] >
	>
	type $shm_hitalama_text_code__highlight_shm_hitalama_text_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['highlight'] >
		,
		ReturnType< $shm_hitalama_text_code['highlight'] >
	>
	type $shm_hitalama_text_code__uri_resolve_shm_hitalama_text_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['uri_resolve'] >
		,
		ReturnType< $shm_hitalama_text_code['uri_resolve'] >
	>
	type $shm_hitalama_text_code__sidebar_showed_shm_hitalama_text_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['pre_sidebar_showed'] >
		,
		ReturnType< $shm_hitalama_text_code['sidebar_showed'] >
	>
	type $shm_hitalama_text_table__head_cells_shm_hitalama_text_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['table_head_cells'] >
		,
		ReturnType< $shm_hitalama_text_table['head_cells'] >
	>
	type $shm_hitalama_text_table__rows_shm_hitalama_text_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['table_rows'] >
		,
		ReturnType< $shm_hitalama_text_table['rows'] >
	>
	type $shm_hitalama_text_table__rows_shm_hitalama_text_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['grid_rows'] >
		,
		ReturnType< $shm_hitalama_text_table['rows'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_text_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['spoiler_content'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $shm_hitalama_text_list__uri_resolve_shm_hitalama_text_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['uri_resolve'] >
		,
		ReturnType< $shm_hitalama_text_list['uri_resolve'] >
	>
	type $shm_hitalama_text_list__type_shm_hitalama_text_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['list_type'] >
		,
		ReturnType< $shm_hitalama_text_list['type'] >
	>
	type $shm_hitalama_text_list__text_shm_hitalama_text_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['list_text'] >
		,
		ReturnType< $shm_hitalama_text_list['text'] >
	>
	type $shm_hitalama_text_list__highlight_shm_hitalama_text_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['highlight'] >
		,
		ReturnType< $shm_hitalama_text_list['highlight'] >
	>
	type $shm_hitalama_text_list__favicon_shm_hitalama_text_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_text['favicon'] >
		,
		ReturnType< $shm_hitalama_text_list['favicon'] >
	>
	export class $shm_hitalama_text extends $mol_text {
		favicon( ): boolean
		render_visible_only( ): boolean
		Embed( id: any): $shm_hitalama_text_embed
		Quote( id: any): $shm_hitalama_text
		Pre( id: any): $shm_hitalama_text_code
		Table( id: any): $shm_hitalama_text_table
		Grid( id: any): $shm_hitalama_text_table
		Spoiler_content( id: any): $shm_hitalama_text
		List( id: any): $shm_hitalama_text_list
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map